import { useEffect } from "react";
import { NavLink, useHistory } from "react-router-dom";

import { Container } from "./LoginStyles";

import TitleLogo from "./TitleLogo";
import InputAuth from "../Forms/InputAuth";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import LoaderDots from "../generalComponents/LoaderDots";
import { HomeWrap } from "../../wrapper";
import { useDispatch, useSelector } from "react-redux";
import { startLoginEmailPassword } from "../../actions/auth";
import AlertPopUp from "../generalComponents/AlertPopUp";
// import { removeLoading, setLoading } from "../../actions/ui";

const LoginForm = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  //Redux
  const { msgAlert } = useSelector((state) => state.alert);
  const { loading } = useSelector((state) => state.ui);
  const { authenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (authenticated) {
      // history.push("/creator");
      history.replace("/creator");
    }

    //eslint-disable-next-line
  }, [authenticated, history]);

  const initialValues = {
    email: "",
    password: "",
  };

  const loginSchema = Yup.object().shape({
    email: Yup.string().required("Email Required"),
    password: Yup.string().required("Password Required"),
  });

  const handleFormikSubmit = (values) => {
    dispatch(startLoginEmailPassword(values));
  };

  return (
    <Container>
      <TitleLogo title="Welcome" to="to" />

      <Formik
        validationSchema={loginSchema}
        initialValues={initialValues}
        onSubmit={handleFormikSubmit}
      >
        {() => {
          return (
            <div className="form">
              <Form>
                <InputAuth name="email" label="Email" type="email" />
                <InputAuth name="password" label="Password" type="password" />
                {msgAlert && (
                  <AlertPopUp msg={msgAlert.msg} type={msgAlert.type} />
                )}
                <button className="btn btn-login login__btn" type="submit">
                  {loading ? <LoaderDots /> : "Login"}
                </button>
                <div className="login__status">
                  <p>Not on Multi-edu yet?</p>
                  <NavLink className="login__status--link" to="/register">
                    Sign-up
                  </NavLink>
                </div>
              </Form>
            </div>
          );
        }}
      </Formik>
    </Container>
  );
};

export default HomeWrap(LoginForm);
